module.exports = __webpack_public_path__ + "img/mark.3ff95842.png";